<template>
  <DBox
    :id="'cmp-catalog-product-sidewindow-manufacturing'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="$t('add_new') + ' ' + $t('manufacturing')"
    @add_click="onAddClick"
  >
    <div class="ut-fh">
      <NTable
        class="dbox1"
        id="catalog-releases-sidewindow-related_tracks"
        :config="tableConfig"
        :headers="Headers"
        :items="list"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr>
            <td v-bind="tdcon('order_date')">
              <span
                @click="onSupplyClick(item)"
                class="ut-link ut-text-accent5"
                >{{ item["supplier_order_date"] }}</span
              >
            </td>
            <td v-bind="tdcon('supplier')">
              <span>{{ item["supplier_name"] }}</span>
            </td>
            <td v-bind="tdcon('status1')">
              <div class="ut-flex" style="width: 80%">
                <div
                  class="circle-status"
                  :style="{
                    backgroundColor: `#${
                      item['accounted_date'] ? '64c896' : 'ff6e6e'
                    }`,
                    width: '14px',
                    height: '14px',
                    minWidth: '14px',
                  }"
                ></div>
                <div style="margin-top: -2px">
                  <template v-if="item['accounted_date']">{{
                    item["accounted_date"]
                  }}</template
                  ><template v-else>{{$t('open')}}</template>
                </div>
              </div>
              <!-- <span>Open</span> -->
            </td>
            <td v-bind="tdcon('qty')">
              <span class="txtov text-right">{{
                item["total_final_qty"]
              }}</span>
            </td>
          </tr>
        </template>
      </NTable>
    </div>

    <!-- <div
      style="
        height: 10px;
        margin-right: 20px;
        flex-direction: column;
        bottom: 3px;
      "
      class="dbox-bottom-right ut-flex ut-jend"
    >
      <div style="display: flex">
        <div style="color: var(--text-secondary)">
          Total Manufacturing Orders:
        </div>
        <div style="font-weight: bold; min-width: 50px; text-align: right">
          {{ totalStock }}
        </div>
      </div>
      <div style="display: flex">
        <div
          style="
            color: var(--text-secondary);
            min-width: 158px;
            text-align: right;
          "
        >
          Total Print Parts:
        </div>
        <div style="font-weight: bold; min-width: 50px; text-align: right">
          {{ totalStock }}
        </div>
      </div>
    </div> -->
    <template slot="bottomRight">
      <div class="ut-fc ut-colcen ut-fh ut-mr-10px">
        <div class="ut-flex ut-jend">
          <div style="color: var(--text-secondary)">
            {{ $t("total_manufacturing_orders") }}:
          </div>
          <div style="min-width: 40px; text-align: right">
            <b>{{ selectedProductDetails.manufact_qty }}</b>
          </div>
        </div>
        <div class="ut-flex ut-jend">
          <div style="color: var(--text-secondary)">
            {{ $t("total_print_parts") }}:
          </div>
          <div style="min-width: 40px; text-align: right">
            <b>{{ selectedProductDetails.total_paper_part_qty }}</b>
          </div>
        </div>
      </div>
    </template>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { distributionSupplierListLDTRoutes, distributionSupplierOrderListLDTRoutes } from "../../../distribution/router/routes";

export default {
  props: {
    selectedProductDetails: {
      type: Object,
    },
  },
  components: {
    NTable,
    DBox,
  },
  data: function () {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      }),
    };
  },
  computed: {
    Headers: function () {
      return [
        createTableHeader("order_date", { f: 0.6 }),
        createTableHeader("supplier", { f: 1 }),
        createTableHeader("status1", {
          f: 0.7,
          ta: "left",
          text: 'status',
        }),

        createTableHeader("qty", { f: 0.6, ta: "right" }),
      ];
    },

    totalStock: function () {
      if (this.list.length > 0) {
        return this.list.reduce((acc, cur) => {
          return acc + parseInt(cur["total_final_qty"]);
        }, 0);
      }
      return 0;
    },
    list: function () {
      return this.selectedProductDetails.manufacturing_orders || [];
    },
  },

  methods: {
    onAddClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_manufacture",
          external_id: this.selectedProductDetails.product.product_id,
        },
      });
    },

    onSupplyClick: function (item) {
      // distributionSupplierListLDTRoutes
      //distributionSupplierOrderListLDTRoutes
      this.$router.push({
        name:  distributionSupplierOrderListLDTRoutes.names.tab,
        params: {
          supplier_order_id: item.supplier_order_id,
          tab: "overview"
        }
      });
    },
  },
};
</script>
<style lang="scss">
.cmp-catalog-product-sidewindow-manufacturing {
  .dt-ntable {
    /* --ntable-height: 170px; */
  }
  .i-icon-box {
    background-color: var(--emerald);
    color: white;
    font-weight: 400;
    display: grid;
    place-items: center;
  }
}
</style>
